import BNLink from "../../../../BnComponents/BNLink/BNLink";
import Media from "../../../../CmsComponents/Media/Media";
import RichText from "../../../../CmsComponents/RichText/RichText";
import Button from "../Button/Button";
import { BNBox, BNStack } from "@bn-monorepo/js-packages";
import { Paper, Typography } from "@mui/material";
import { Image } from "../Section/Section";

interface Item {
  img?: Image;
  title: string;
  paragraph: string;
  button: string;
  href: string;
  isSpa: boolean;
  linkOnImageAndTitleIsSpa?: boolean;
  linkOnImageAndTitleHref?: string;
}

interface Props {
  header: string;
  itemList: Item[];
  enabled?: boolean;
}

const CardSectionCarousel: React.FC<Props> = (props) => {
  const { header, itemList: articles, enabled } = props;
  if (!enabled) return null;
  return (
    <BNBox sx={{ mx: 2, textAlign: "center" }} component={"section"}>
      {header && <h2>{header}</h2>}
      {articles && (
        <BNBox
          sx={{
            mx: "auto",
            display: "grid",
            flexWrap: "wrap",
            justifyContent: "center",
            gap: 2,
            gridTemplateColumns: {
              xs: "repeat(1, 1fr)",
              sm: "repeat(2, 1fr)",
              md: "repeat(3, 1fr)",
            },
            maxWidth: "120rem",
          }}
        >
          {articles.map((article, index) => (
            <BNStack
              component={Paper}
              key={`article-${index}`}
              sx={({ vars }) => ({ borderRadius: `calc(8 * ${vars.shape.borderRadius})`, overflow: "hidden" })}
            >
              {article.img &&
                (article.linkOnImageAndTitleHref ? (
                  <BNLink
                    isSpa={article.linkOnImageAndTitleIsSpa || false}
                    href={article.linkOnImageAndTitleHref}
                    tabIndex={article.href ? -1 : undefined}
                  >
                    <CarouselImage image={article.img} />
                  </BNLink>
                ) : (
                  <CarouselImage image={article.img} />
                ))}
              <BNStack
                sx={{
                  gap: 1,
                  p: 2,
                }}
              >
                {article.title && article.linkOnImageAndTitleHref ? (
                  <BNLink
                    isSpa={article.linkOnImageAndTitleIsSpa || false}
                    href={article.linkOnImageAndTitleHref}
                    tabIndex={article.href ? -1 : undefined}
                  >
                    <CarouselTitle title={article.title} />
                  </BNLink>
                ) : (
                  <CarouselTitle title={article.title} />
                )}
                <RichText html={article.paragraph} />
                {article.href && (
                  <BNBox>
                    <Button
                      text={article.button}
                      href={article.href}
                      isSpa={article.isSpa}
                      type="blue"
                      textAlign={"center"}
                    />
                  </BNBox>
                )}
              </BNStack>
            </BNStack>
          ))}
        </BNBox>
      )}
    </BNBox>
  );
};
export default CardSectionCarousel;

export const CarouselTitle: React.FC<{ title?: string }> = ({ title }) => {
  if (!title) return null;
  return (
    <Typography component={"h3"} variant="h5" sx={{ color: "text.primary", fontWeight: "bold" }}>
      {title}
    </Typography>
  );
};
export const CarouselImage: React.FC<{
  image: Image;
}> = ({ image }) => {
  if (!image) return null;
  return (
    <Media
      AltText={image.alt}
      imagePath={image.url}
      noWrapper={true}
      maxWidth={image.width}
      aspectRatio={`${image.width}:${image.height}`}
      sx={{ width: "100%" }}
    />
  );
};
